import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { TrackableEntity } from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';

export class BtLoadDetailOrder extends TrackableEntity {
    id: number = 0;
    loadId: number = 0;
    orderId: number = 0;
    seqNo: number = 0;
    dest: number = 0;
    destPort: string = '';
    destName: string = '';
    destCityState: string = '';
    origin: number = 0;
    originPort: string = '';
    originName: string = '';
    originCityState: string = '';
    orderDestPort: string = '';
    orderNo: string = '';
    billTo: number = 0;
    billToName: string = '';
    arrival: string | null = null;
    arrivalTime: string | null = null;
    arrived: boolean = false;
    pkgs: number = 0;
    punit: string = '';
    pkgsUnit: string = '';
    lbs: number = 0;
    cft: number = 0;
    draft: boolean = false;
    statusInvo: string = '';
    statusBill: string = '';

    constructor(init?:Partial<BtLoadDetailOrder>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }
    
    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return  BtLoadDetailOrder.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_BTLOADDETAILORDER' }),
        'loadId': new DBMappingInfo({ field: 'F_LoadID', table: 'T_BTLOADDETAILORDER' }),
        'orderId': new DBMappingInfo({ field: 'F_OrderID', table: 'T_BTLOADDETAILORDER' }),
        'billTo': new DBMappingInfo({ field: 'F_BillTo', table: 'T_BTLOADDETAILORDER' }),
        'origin': new DBMappingInfo({ field: 'F_Origin', table: 'T_BTLOADDETAILORDER' }),
        'dest': new DBMappingInfo({ field: 'F_Dest', table: 'T_BTLOADDETAILORDER' }),
        'arrival': new DBMappingInfo({ field: 'F_Arrival', table: 'T_BTLOADDETAILORDER' }),
        'arrived': new DBMappingInfo({ field: 'F_Arrived', table: 'T_BTLOADDETAILORDER' }),
        'seqNo': new DBMappingInfo({ field: 'F_SeqNo', table: 'T_BTLOADDETAILORDER' }),
    }
}